export default {
  root: { fontSize: 14 },
};
